/**
 * Eerste betekenisvolle regel uit HTML voor sidebar-weergave (geen wijziging aan block.content).
 */
export function firstLinePlainTextFromHtml(html: string, maxLen: number): string | null {
  if (!html || typeof html !== 'string' || !html.trim()) return null;

  const stripped = html
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/<style[\s\S]*?<\/style>/gi, '');

  const withBreaks = stripped
    .replace(/<\/(p|div|h[1-6]|li|tr)\b>/gi, '\n')
    .replace(/<br\s*\/?>/gi, '\n');

  const text = withBreaks
    .replace(/<[^>]+>/g, ' ')
    .replace(/\u00a0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  if (!text) return null;

  const firstLine = text.split(/\n/).map((s) => s.trim()).find(Boolean) || text;
  const t = firstLine.trim();
  if (!t) return null;

  return t.length > maxLen ? `${t.slice(0, maxLen).trim()}…` : t;
}
